import axios from 'axios'

const api = axios.create({
    baseURL: `${window.location.origin}/api/v1`,
    withCredentials: true,
    xsrfCookieName: 'csrf-token',
    timeout: 10000,
})

// Reporting must never interfere with the error boundary's fallback.
export const reportClientError = async (error, errorInfo) => {
    try {
        await api.post('/clientErrors', {
            message: String(error && error.message || error || 'Unknown browser error').slice(0, 2000),
            stack: String(error && error.stack || '').slice(0, 16000),
            componentStack: String(errorInfo && errorInfo.componentStack || '').slice(0, 16000),
            // HashRouter stores the app route in the hash. Omit query parameters.
            route: (window.location.hash.slice(1) || window.location.pathname).split('?')[0].slice(0, 2000),
            occurredAt: new Date().toISOString(),
        })
    } catch (reportError) {
        console.warn('Could not report browser error', reportError)
    }
}
